import React, { useState, useEffect, useRef } from "react";
import { Modal, Alert } from 'antd';
import { svg } from "../../assets/svg/common";
import FileViewer from "react-file-viewer";
import { sidebar_svg } from '../../assets/svg/sidebar.js'
import { storeQuickSent, storeCategory } from '../../helper/apiHelper.js'
import { useLoading } from '../../context/LoadingContext';
import { useDispatch, useSelector } from "react-redux";


const FileReaderModel = (params) => {
    const [fileData, setFileData] = useState(null);
    const [fileType, setFileType] = useState('');
    const fileViewerRef = useRef(null);
    const getFileType = (fileName) => fileName.split(".").pop();
    useEffect(() => {
        if (params.file) {
            const fileURL = window.URL.createObjectURL(params.file);
            setFileData(fileURL);
            setFileType(getFileType(params.file.name));
            return () => window.URL.revokeObjectURL(fileURL);
        } else {
            setFileData(null);
            setFileType('');
        }
    }, [params.file]);

    useEffect(() => {
        if (!params.isOpen) {
            fileViewerRef.current = null;
        }
    }, [params.isOpen]);

    const renderFileViewer = (fileDatas, fileTypes) => {
        if (fileDatas && fileTypes) {
            console.log(fileDatas);
            try {
                return (
                    <FileViewer
                        ref={fileViewerRef}
                        fileType={fileTypes}
                        filePath={fileDatas}
                        errorComponent={<p>Error loading file</p>}
                        onError={(error) => console.error("FileViewer error: ", error)}
                    />
                );
            } catch (error) {
                console.error("Error rendering FileViewer: ", error);
                return <p>Error rendering file viewer</p>;
            }
        } else {
            return <p>No file selected</p>;
        }
    };

    return (
        <Modal
            className="parent-div-content-file-preview"
            open={params.isOpen}
            onOk={params.close}
            onCancel={params.close}
            closeIcon={null}
            footer={null}
        >
            <div className="quicksend-container">
                <div className="file-preview-header">
                    <span>File Preview - {params.file.name}</span>
                    <div onClick={params.close} className="cursor-pointer">
                        {svg.close}
                    </div>
                </div>

                <div className="file-rendering-section">
                    {renderFileViewer(fileData, fileType)}
                </div>
            </div>
        </Modal>
    );
};

const QuickSent = (params) => {
    const [newUser, setNewUser] = useState('');
    const [alertInfo, setAlertInfo] = useState({});
    const { showLoader, hideLoader } = useLoading();
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const dispatch = useDispatch();


    const handleCloseAlert = () => {
        setAlertInfo({ ...alertInfo, show: false });
    };

    const validateUser = async (userValue) => {
        const emailRegex = /^[a-zA-Z0-9._@]+$/;
        if (!emailRegex.test(userValue)) {
            setAlertInfo({ message: 'Please enter a valid email address.', type: 'warning', autoClose: 5000, show: true });
            return false;
        }
        const atCount = (userValue.match(/@/g) || []).length;
        if (atCount !== 1) {
            setAlertInfo({ message: 'Please enter a valid email address.', type: 'warning', autoClose: 5000, show: true });
            return false;
        }
        return true;
    }
    async function quickAccessAction(userValue) {
        showLoader();
        if (!isQuickList(userValue)) {
            await storeQuickSent(userValue);
            dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
            params.close();
        } else {
            setAlertInfo({ message: 'User already added in quick send', type: 'warning', autoClose: 5000, show: true });
        }
        hideLoader();
    }

    const isQuickList = (userValue) => {
        return params.quickUserList.filter(list => list.email == userValue).length == 0 ? false : true;
    }

    return (
        <Modal
            className="parent-div-content-quicksend-preview"
            open={params.isOpen}
            onOk={params.close}
            onCancel={params.close}
            closeIcon={null}
            footer={null}
        >
            {alertInfo.show && <CustomAlert message={alertInfo.message} type={alertInfo.type} autoClose={alertInfo.autoClose} onClose={handleCloseAlert} />}
            <div className="quicksend-container">
                <div className="quicksend-preview-header d-flex justify-content-between align-items-center">
                    <span>Add Contact for Quick Send</span>
                    <div onClick={params.close} className="cursor-pointer">
                        {svg.close}
                    </div>
                </div>
                <hr />
                <div className="quicksend-rendering-section mt-4">
                    <div className='user-details-section user-profile-render-data d-flex justify-content-between align-items-center'>
                        <div className='user-profile-name inbox quick-send input-field-search-user d-flex gap-2 align-items-center'>
                            <div className='user-profile-pic'>{newUser.charAt(0).toUpperCase() || '#'}</div>
                            <div className='user-profile-name inbox quick-send input-field-search-user'>
                                <input className="common-input input-search-user width-24rem" type="text" onChange={(e) => { setAlertInfo({ show: false }); setNewUser(e?.target?.value?.trim()?.toLowerCase()) }} value={newUser} placeholder="Add New User" maxLength="225" />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                        <button className="general-save-btn" onClick={async () => {
                            const isValid = await validateUser(newUser);
                            if (isValid) { quickAccessAction(newUser); }
                        }}>Save</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const Category = (params) => {
    const [categryName, setCategryName] = useState('');
    const [alertInfo, setAlertInfo] = useState({});
    const { showLoader, hideLoader } = useLoading();
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const dispatch = useDispatch();


    const handleCloseAlert = () => {
        setAlertInfo({ ...alertInfo, show: false });
    };

    const validateUser = async (name) => {
        if (!name) {
            setAlertInfo({ message: 'Please enter a valid name.', type: 'warning', autoClose: 5000, show: true });
            return false;
        }
        if (name.length < 3) {
            setAlertInfo({ message: 'Name must be at least 3 characters long.', type: 'warning', autoClose: 5000, show: true });
            return false;
        }
        if (name.length > 20) {
            setAlertInfo({ message: 'Name must be at most 20 characters long.', type: 'warning', autoClose: 5000, show: true });
            return false;
        }
        return true;
    }
    async function quickAccessAction(userValue) {
        showLoader();
        if (!isCategryList(userValue)) {
            await storeCategory(userValue);
            dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
            params.close();
        } else {
            setAlertInfo({ message: 'Category name already exist', type: 'warning', autoClose: 5000, show: true });
        }
        hideLoader();
    }

    const isCategryList = (userValue) => {
        return params.categryList.filter(list => list.category_name == userValue).length == 0 ? false : true;
    }

    return (
        <Modal
            className="parent-div-content-quicksend-preview"
            open={params.isOpen}
            onOk={params.close}
            onCancel={params.close}
            closeIcon={null}
            footer={null}
        >
            {alertInfo.show && <CustomAlert message={alertInfo.message} type={alertInfo.type} autoClose={alertInfo.autoClose} onClose={handleCloseAlert} />}
            <div className="quicksend-container">
                <div className="quicksend-preview-header d-flex justify-content-between align-items-center">
                    <span>Add Category</span>
                    <div onClick={params.close} className="cursor-pointer">
                        {svg.close}
                    </div>
                </div>
                <hr />
                <div className="quicksend-rendering-section mt-4">
                    <div className='user-details-section user-profile-render-data d-flex justify-content-center align-items-center'>
                        <div className='user-profile-name inbox quick-send input-field-search-user d-flex gap-2 align-items-center'>
                            <div className='user-profile-name inbox quick-send input-field-search-user d-flex justify-content-center'>
                                <input className="common-input input-search-user width-24rem" type="text" onChange={(e) => { setAlertInfo({ show: false }); setCategryName(e?.target?.value?.trim()?.toLowerCase()) }} value={categryName} placeholder="Add New category" maxLength="20" />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                        <button className="general-save-btn" onClick={async () => {
                            const isValid = await validateUser(categryName);
                            if (isValid) { quickAccessAction(categryName); }
                        }}>Save</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const CustomAlert = ({ message, type, autoClose, onClose }) => {
    useEffect(() => {
        if (autoClose) {
            const timer = setTimeout(onClose, autoClose);
            return () => clearTimeout(timer);
        }
    }, [autoClose, onClose]);
    return (
        <Alert message={message} type={type} showIcon onClose={onClose} closable />
    );
};

export {
    FileReaderModel,
    QuickSent,
    Category
}
